import type { CreateCompanyFormData } from '../schemas/company.schemas';
import type { CreateCompanyRequest } from '../types/company.types';

export const ACCEPTED_IMAGE_TYPES = 'image/png,image/jpeg,image/webp,image/svg+xml';

export function transformCompanyFormData(data: CreateCompanyFormData): CreateCompanyRequest {
  return {
    name: data.name,
    email: data.email,
    country: data.country ?? '',
    taxId: data.taxId || undefined,
    description: data.description || undefined,
    website: data.website || undefined,
    phone: data.phone || undefined,
    address: data.address || undefined,
    city: data.city || undefined,
    industry: data.industry || undefined,
    companySize: data.companySize || undefined,
  };
}
